import type { StaffRole } from '../types/auth';

/**
 * PRO-3040 / ADR-018 — every school-scoped role that raises ATRs, i.e. holds
 * `atr_submit` + `atr_request_read` in the API capability map. One list for the
 * API scope guard (`assertAtrRequesterScope`), the SPA route set (`ATR_ROLES`)
 * and the SPA requester checks, drift-tested against `CAPABILITIES` in
 * `apps/api/test/atrRequesterRoles.test.ts`. Pure and type-only on `StaffRole`
 * so the SPA bundle can import it without `pg`.
 */
export const ATR_REQUESTER_ROLES: readonly StaffRole[] = [
  'ATR_REQUESTER',
  'PRINCIPAL',
  'SCHOOL_BUSINESS_MANAGER',
];

export function isAtrRequesterRole(role: StaffRole): boolean {
  return ATR_REQUESTER_ROLES.includes(role);
}

export function holdsAtrRequesterRole(roles: readonly { readonly role: StaffRole }[]): boolean {
  return roles.some((assignment) => isAtrRequesterRole(assignment.role));
}
